
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M22 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0M44 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0M22 25a4 4 0 1 1-8 0 4 4 0 0 1 8 0M33 25a4 4 0 1 1-8 0 4 4 0 0 1 8 0M44 25a4 4 0 1 1-8 0 4 4 0 0 1 8 0M11 36a4 4 0 1 1-8 0 4 4 0 0 1 8 0M22 36a4 4 0 1 1-8 0 4 4 0 0 1 8 0M33 36a4 4 0 1 1-8 0 4 4 0 0 1 8 0M44 36a4 4 0 1 1-8 0 4 4 0 0 1 8 0","fill":"#D0EFEC"}}),_c('circle',{staticClass:"i-Ellipse 21",attrs:{"cx":"8","cy":"12","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 22",attrs:{"cx":"19","cy":"12","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 23",attrs:{"cx":"30","cy":"12","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 24",attrs:{"cx":"41","cy":"12","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 25",attrs:{"cx":"8","cy":"23","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 26",attrs:{"cx":"19","cy":"23","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 27",attrs:{"cx":"30","cy":"23","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 28",attrs:{"cx":"41","cy":"23","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 29",attrs:{"cx":"8","cy":"34","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 30",attrs:{"cx":"19","cy":"34","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 31",attrs:{"cx":"30","cy":"34","r":"3.5","stroke":"#234652"}}),_c('circle',{staticClass:"i-Ellipse 32",attrs:{"cx":"41","cy":"34","r":"3.5","stroke":"#234652"}})])
          )
        }
      }
    